import axios from "axios";
import { useState, useEffect } from "react";
import { Col, Row, Collapse } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../App";
import '../../styles/years.css';
import ScrollTopButton from "../ScrollTop";
import CardNot from "../Cardnotlogin";
import CardLogin from "../Cardlogin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import MathLoading from "../MathLoading";
import {
  collectOwnedCourseIds,
  isUserCenterStudent,
  isUserOnlineStudent,
} from "../courseUtils";

const CategorySection = ({ categoryItem, type, style, loggedIn, ownedCourseIds }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);
  const isLoggedIn = Boolean(loggedIn);

  if (!categoryItem.courses || categoryItem.courses.length === 0) {
    return null;
  }

  return (
    <>
    <div className="category-accordion">
      <div className="category-header" onClick={toggleOpen}>
        <h3 className="category-title">
          <FontAwesomeIcon icon={faBook} className="pushpin-icon" />
          {categoryItem.category.name}
        </h3>
        <button type="button" className="toggle-button">
          <span>{isOpen ? 'أخفيلي المحتويات' : 'اعرضلي المحتويات'}</span>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </button>
      </div>
      <Collapse in={isOpen}>
        <div className="courses-wrapper">
          <Row>
            {categoryItem.courses.map((course) => (
              <Col lg={4} md={6} className="mb-5" key={`${type}-${course.id}`}>
                {isLoggedIn ? (
                  <CardLogin
                    cardcourse={course}
                    style={style}
                    ownedCourseIds={ownedCourseIds}
                  />
                ) : (
                  <CardNot
                    cardonline={type === "online" ? course : undefined}
                    cardcenter={type === "center" ? course : undefined}
                    style={style}
                  />
                )}
              </Col>
            ))}
          </Row>
        </div>
      </Collapse>
    </div>
    </>
  );
};


function Courses({ style, loggedIn, auth }) {
  const [onlineData, setOnlineData] = useState(null);
  const [centerData, setCenterData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [ownedCourseIds, setOwnedCourseIds] = useState(() => new Set());
  const { id } = useParams();
  const isLoggedInUser = Boolean(loggedIn ?? localStorage.getItem("token"));
  const showOnlineSection = !isLoggedInUser || isUserOnlineStudent(auth);
  const showCenterSection = !isLoggedInUser || isUserCenterStudent(auth);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      setIsLoading(true);
      const token = localStorage.getItem('token');
      const config = { headers: { 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "any", 'Authorization': `Bearer ${token}` } };
      try {
        const delay = new Promise(resolve => setTimeout(resolve, 2000));

        if (showOnlineSection) {
          const onlineRes = await axios.get(`${BASE_URL}/api/show-level-online-courses/${id}`, config);
          setOnlineData(onlineRes.data.data || { categories: [] });
        } else {
          setOnlineData({ categories: [] });
        }

        if (showCenterSection) {
          try {
            const centerRes = await axios.get(`${BASE_URL}/api/show-level-offline-courses/${id}`, config);
            setCenterData(centerRes.data.data || { categories: [] });
          } catch (centerError) {
            console.error("Failed to fetch center courses", centerError);
            setCenterData({ categories: [] });
          }
        } else {
          setCenterData({ categories: [] });
        }

        if (token && isLoggedInUser) {
          try {
            const ownedRes = await axios.get(`${BASE_URL}/api/my-weeks`, config);
            setOwnedCourseIds(collectOwnedCourseIds(ownedRes));
          } catch (ownedError) {
            console.error("Failed to fetch owned courses", ownedError);
            setOwnedCourseIds(new Set());
          }
        } else {
          setOwnedCourseIds(new Set());
        }
        
        await delay;
      } catch (error) {
        console.error("Failed to fetch online courses", error);
        setOnlineData({ categories: [] });
        setCenterData({ categories: [] });
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id, isLoggedInUser, showOnlineSection, showCenterSection]);

  if (isLoading) {
    return (
      <div className={`main-loading ${style ? 'dark-mode' : ''}`}>
        <div className="loading-course">
                <MathLoading />

        </div>
      </div>
    );
  }


  const hasOnlineContent = onlineData?.categories?.some(c => c.courses?.length > 0);
  const hasCenterContent = centerData?.categories?.some(c => c.courses?.length > 0);

  return (
    <>
      <div className={`courses-page-content ${style ? 'dark-mode' : ''}`}>
          {showOnlineSection && (
            <>
          <div className="title-section">
            <h2>كورسات الأونلاين</h2>
          </div>
          {hasOnlineContent ? (
            onlineData.categories.map((catItem) => (
              <CategorySection
                key={`online-cat-${catItem.category.id}`}
                categoryItem={catItem}
                type="online"
                style={style}
                loggedIn={isLoggedInUser}
                ownedCourseIds={ownedCourseIds}
              />
            ))
          ) : (
            <div className="no-content-container">
  <div className="icon-wrapper-not">
    <span className="icon-line line-1"></span>
    <span className="icon-line line-2"></span>
  </div>
      <h2>لا توجد كورسات أون لاين حالياً</h2>
              <p>! سيتم اضافة الكورسات قريبا , تابعنا</p>
</div>
          )}
            </>
          )}

          {showCenterSection && (
            <>
              <div className="title-section" style={{marginTop: showOnlineSection ? '80px' : 0}}>
                <h2>كورسات السنتر</h2>
              </div>
              {hasCenterContent ? (
                centerData.categories.map((catItem) => (
                  <CategorySection
                    key={`center-cat-${catItem.category.id}`}
                    categoryItem={catItem}
                    type="center"
                    style={style}
                    loggedIn={isLoggedInUser}
                    ownedCourseIds={ownedCourseIds}
                  />
                ))
              ) : (
                <div className="no-content-container">
  <div className="icon-wrapper-not">
    <span className="icon-line line-1"></span>
    <span className="icon-line line-2"></span>
  </div>
      <h2>لا توجد كورسات  سنتر حالياً</h2>
              <p>! سيتم اضافة الكورسات قريبا , تابعنا</p>
</div>
              )}
            </>
          )}
      </div>
      <ScrollTopButton />
    </>
  );
}

export default Courses;
